import React from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setTabs } from '../redux/slices/tabsDataSlice';
import { setOthers } from '../redux/slices/othersDataSlice';
import { setSitePath, setTabOrPublicationPage } from '../redux/slices/appSlice';
import { setNews } from '../redux/slices/newsSlice';
import { setAuthorCards } from '../redux/slices/authorCardsSlice';
import { extractAuthorCardsFromOthers } from '../utils/extractAuthorCardsFromOthers';
import getSiteDataFunctions from './get_site_data_fns';
import { path_to_site } from './axios_settings';
import { handleNetworkError } from '../utils/networkErrorHandler';
import { normalizeSiteDataMediaPaths } from '../utils/normalizePublicMediaPath';

const GetSiteData = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const dataVersion = useSelector((state) => state.app.dataVersion);
  const [localDataVersion, setLocalDataVersion] = React.useState(0);

  React.useEffect(() => {
    // console.log(
    //   'GetSiteData useEffect triggered, localDataVersion:',
    //   localDataVersion,
    //   'dataVersion:',
    //   dataVersion,
    // );
    // Проверяем, соответствует ли локальная версия глобальной
    if (localDataVersion !== dataVersion) {
      // console.log('Making API request to get site data...');
      const formData = new FormData();
      formData.append('request', 'get_client_data');

      axios
        .post(path_to_site, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => {
          const normalizedData = normalizeSiteDataMediaPaths(data);
          // console.log('GetSiteData response:', normalizedData);
          // Используем функцию для поиска main_tab элемента
          const mainTabElement = getSiteDataFunctions.findMainTabElement(normalizedData);
          // Получаем путь из строки браузера
          const currentPath = location.pathname;
          // Используем функцию для обработки пути
          const { currentTabPath, currentPublicationPath } = getSiteDataFunctions.processPath(
            currentPath,
            normalizedData,
            mainTabElement,
          );
          //   console.log(currentTabPath, normalizedData.tabs);
          // console.log(currentPublicationPath, normalizedData.others);
          // console.log('Dispatching setOthers with data.others:', normalizedData.others);
          dispatch(setTabs(normalizedData.tabs));
          dispatch(setNews(normalizedData.tabs));
          dispatch(setOthers(normalizedData.others));
          dispatch(setAuthorCards(extractAuthorCardsFromOthers(normalizedData.others)));

          let fullPath = '';
          if (currentPublicationPath !== '') {
            fullPath = currentTabPath + '/' + currentPublicationPath;
            dispatch(setTabOrPublicationPage('publication'));
          } else {
            fullPath = currentTabPath;
            dispatch(setTabOrPublicationPage('tab'));
          }

          dispatch(setSitePath(fullPath));

          // Обновляем локальную версию после успешного запроса
          setLocalDataVersion(dataVersion);
        })
        .catch((error) => {
          // Обрабатываем сетевые ошибки (отсутствие интернета)
          if (handleNetworkError(error)) {
            return; // Игнорируем сетевые ошибки
          }

          // Для других ошибок можно добавить логирование, но не показывать пользователю
          // console.error('Error in GetSiteData:', error);
        });
    }
  }, [localDataVersion, dataVersion, dispatch, location, navigate]);

  return null;
};

export default GetSiteData;
